module.exports = __webpack_public_path__ + "img/report.a8290b49.png";